import {
  getWeaknessCatalogEntryById,
  resolveWeaknessCatalogEntry,
  type InternalNetworkWeaknessCatalogEntry,
} from './internal-network-weakness-catalog';

const ACL_ABUSE_WEAKNESS_ID = 'TN-AD-0010';

export const isDomainCompromiseProofCommand = (
  command: string | null | undefined,
): command is 'dcsync' | 'acl_abuse' =>
  command === 'dcsync' || command === 'acl_abuse';

const catalogEntryProvesDomainCompromise = (
  entry: InternalNetworkWeaknessCatalogEntry,
): boolean =>
  entry.infraImpact === 'DOMAIN_COMPROMISE' ||
  entry.weaknessId === ACL_ABUSE_WEAKNESS_ID;

export const isDomainCompromiseProofWeakness = ({
  technique,
  weaknessId,
}: {
  technique?: string | null;
  weaknessId?: string | null;
}): boolean => {
  if (weaknessId) {
    const byId = getWeaknessCatalogEntryById(weaknessId);

    if (byId && catalogEntryProvesDomainCompromise(byId)) {
      return true;
    }
  }

  if (isDomainCompromiseProofCommand(technique)) {
    return true;
  }

  if (!technique) {
    return false;
  }

  const entry = resolveWeaknessCatalogEntry({
    edgeType: technique,
    technique,
  });

  return entry ? catalogEntryProvesDomainCompromise(entry) : false;
};
